export default __webpack_public_path__ + "static/media/04.50867a1f.png";